import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { currencyInput } from './config/currencyInput';
import { Validators } from '@angular/forms';
import { CurrencyHelper } from '@shared/helpers/decimals.helper';
import { OperationConceptService } from '@modules/operations/services/operation_concept.service';
import { OperationDetails } from '@modules/operations/Domain/operation.model';
import { canAddConceptValidator } from '@shared/validators/forms/canAddConcept';

@Component({
  selector: 'app-currency-modal',
  templateUrl: './currency-modal.component.html',
  styleUrls: ['./currency-modal.component.scss'],
})
export class CurrencyModalComponent implements OnInit {
  currencyInput = currencyInput;
  operation: OperationDetails = {} as OperationDetails;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private operationConceptService: OperationConceptService,
  ) {}

  ngOnInit(): void {
    const amount = CurrencyHelper.toDecimal(this.config.data.amount);
    const concept = this.config.data.concept;
    this.operation = this.config.data.operation;

    currencyInput[1].setPropertyValue('validators', [Validators.min(-999999999)]);
    currencyInput[0].setPropertyValue('value', concept);
    currencyInput[1].setPropertyValue('value', amount);

    currencyInput[1].setPropertyValue('validators', [
      Validators.min(-999999999),
      canAddConceptValidator(this.operation), // Add custom validator here
    ]);
  }

  send(data: any) {
    if (this.operationConceptService.canAddConcept(this.operation, data.amount)) {
      data.amount = CurrencyHelper.toCents(data.amount);
      this.ref.close(data);
    } else {
      this.ref.close(null);
    }
  }
}
